module.exports = __webpack_public_path__ + "static/media/slovenia.c301b2b4.png";